module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$store.state.is_auth && (_vm.$route.path.indexOf('/operation/select/') === 0 || _vm.$route.path.indexOf('/operation/pay/') === 0 || _vm.$route.path.indexOf('/operation/view/') === 0 || _vm.$route.path === '/operation/list')) ? _c('div', [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top",
    staticStyle: {
      "right": "-15px"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand w5-navbar-logo-link",
    attrs: {
      "href": _vm.MainSite
    }
  }, [_c('img', {
    staticClass: "w5-navbar-logo-img visible-xs",
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "w5-navbar-logo-img hidden-xs",
    attrs: {
      "src": _vm.stylePathToLogoText || '/static/img/logo/logo-text.png'
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3"
  }, [_c('router-view')], 1)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a741d06"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/operationPage.vue
// module id = 773
// module chunks = 0